<!-- Advanced country picker -->
@if (advancedMode) {
  <div class="row">
    <div class="col-12 lh-tel-input">
      <input
        tabindex="{{ tabindex }}"
        class="form-control"
        type="tel"
        [attr.id]="inputId"
        [attr.aria-label]="placeholder"
        [attr.aria-invalid]="ariaInvalid || null"
        [attr.aria-describedby]="ariaDescribedBy || null"
        [(ngModel)]="phoneNumber"
        [readonly]="readonly"
        lhIntlTelInput
        lhSharedDirectiveAutoFocus
        [lhAutoFocus]="requestFocus"
        [intlTelInputOptions]="advancedOptions"
        (inputChange)="onIntlTelInputChange($event)"
        (focus)="onInputFocus()"
        (blur)="onInputBlur()"
        #intlTelInput
      />
    </div>
  </div>
}

@if (!advancedMode) {
  <div>
    <!-- Simple country picker -->
    @if (countries) {
      <div class="row">
        <div class="col-3 left-col">
          <select class="form-select country" name="country" [(ngModel)]="selectedDialCode">
            @for (country of countries; track country) {
              <option [value]="country.dialCode">
                {{ country.countryCode }}
              </option>
            }
          </select>
        </div>
        <div class="col-9 right-col text-end">
          <span class="dial-code">{{ selectedDialCode }}</span>
          <input
            class="form-control phone-number pull-right"
            type="tel"
            [attr.id]="inputId"
            [(ngModel)]="phoneNumber"
            [placeholder]="placeholder"
            lhSharedDirectiveAutoFocus
            [lhAutoFocus]="requestFocus"
            (focus)="onInputFocus()"
          />
        </div>
      </div>
    }
    <!-- Plain text input -->
    @if (!countries) {
      <div>
        <input
          class="form-control"
          type="tel"
          [attr.id]="inputId"
          [(ngModel)]="value"
          [placeholder]="placeholder"
          [attr.aria-invalid]="ariaInvalid || null"
          [attr.aria-describedby]="ariaDescribedBy || null"
          lhAutoFocus
        />
      </div>
    }
  </div>
}
